<template lang="pug">
  .dadata-input
    label(:for="name" v-if="label !== ''") {{ label }}
    dadata-suggestions(
      :id="name"
      v-model="value"
      :options="options"
      :fullInfo.sync="valueFull"
      field-value="value"
      :placeholder="placeholder"
      @change="onChange"
    )
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {}
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: 'input'
    },
    initialValue: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
      value: '',
      valueFull: {
        value: '',
        unrestricted_value: ''
      }
    };
  },

  methods: {
    onChange() {
      console.log(this.valueFull);
      this.$emit('input', this.valueFull);
    }
  },

  mounted() {
    this.value = this.initialValue;
    this.valueFull = {
      value: this.initialValue,
      unrestricted_value: this.initialValue
    };
    if (this.initialValue !== '') {
      this.onChange();
    }
  }
};
</script>
